export var isBarberSessionView = function (view) {
    return view.kind === 'barber';
};
export var isShopSessionView = function (view) {
    return view.kind === 'shop';
};
export var isBrandSessionView = function (view) {
    return view.kind === 'brand';
};
export var isAdminView = function (view) {
    return view.kind === 'admin';
};
export var isAgentView = function (view) {
    return view.kind === 'agent';
};
